import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { T } from '../traks';

class PotentialFatalErrorPage extends Component {
	constructor(props) {
		super(props);
		/* some hackery because we're outside of the router (Reout.js)
		 * */
		this.hashchange_listener = () => {
			window.location.reload();
		};
	}

	componentDidUpdate(prev_props, prev_state) {
		if (this.props.fatal_error) {
			window.addEventListener("hashchange", this.hashchange_listener);
		} else {
			window.removeEventListener("hashchange", this.hashchange_listener);
		}
	}

	render() {
		if (this.props.fatal_error) {
			return (
				<Container>
					<Row className="pt-5">
						<Col className="ad_notification_box py-3">
							<img alt="problem" src="/gfx/problem-icon-0.svg"/><b><T>Oops! Seems we're having technical problems or doing some quick maintenance. Try reloading the page. We would like to hear from you if the problem persists after a few minutes.</T></b>
						</Col>
					</Row>
				</Container>
			);
		} else {
			return this.props.children;
		}
	}
}

export default connect(
	(state) => ({fatal_error: state.fatal_error})
)(PotentialFatalErrorPage);



// WEBPACK FOOTER //
// ./src/p/PotentialFatalErrorPage.js